import * as Types from '@/types';

import { gql } from '@apollo/client';
export const AvailabilityTimeslotSettingsFragmentDoc = gql`
  fragment AvailabilityTimeslotSettings on FulfillmentTimeslotSettings {
    default_selection
    lead_time_minutes
    selection_required
    timeslots {
      end_time
      start_time
    }
  }
`;
export const AvailabilityDayFragmentDoc = gql`
  fragment AvailabilityDay on OrderFulfillmentAvailability {
    cutoff_time
    date
    lead_time_days
    order_minimum_display_string
    timeslot_settings {
      ...AvailabilityTimeslotSettings
    }
  }
  ${AvailabilityTimeslotSettingsFragmentDoc}
`;
export const AvailableOrderFulfillmentFieldsFragmentDoc = gql`
  fragment AvailableOrderFulfillmentFields on GetAvailableOrderFulfillmentResponse {
    availability {
      ...AvailabilityDay
    }
    default_cutoff_time
    default_lead_time_days
    fulfillment_disclaimer
    fulfillment_display_name
    fulfillment_name
    fulfillment_settings_id
    fulfillment_type
    order_minimum_display_string
    primary_fulfillment_settings_id
  }
  ${AvailabilityDayFragmentDoc}
`;
